<div class="d-flex" [class]="colorClass + ' badge'">
  <mat-icon inline *ngIf="icon">{{ icon }}</mat-icon>
  {{text}}
</div>
